<!--
  width: String => "100px"
  height: String  => "100px"
  radius: String => "10px"
  radiusTop: String =>"10px"
  fit:String  => "fill"  "cover"  "contain"
  src: String,暂时只支持加密的图片url地址
  example:
  <HCacheImage
      width="100px"
      radius="4px"
      src="https://ylhgcdncfwebpass.xyz/pass/main/ad/yl_pop_250312_200X200.png"
  />
-->
<template>
  <div class="relative w-full h-full"
       ref="containerRef"
       :style="{
          position:'relative',
          width: width ? width : 'auto',
          height: height ? height: 'auto',
          borderRadius: radius ? radius : '0',
          borderTopLeftRadius:radiusTop?radiusTop:'0',
          borderTopRightRadius:radiusTop?radiusTop:'0',
        }"
  >
    <div v-if="!loaded && shimmerDuration!==''" class="absolute inset-0 shimmer-bg rounded z-10" :style="{
          width: width ? width : height,
          height: height ? height: width,
          borderRadius: radius ? radius : '0',
          borderTopLeftRadius:radiusTop?radiusTop:'0',
          borderTopRightRadius:radiusTop?radiusTop:'0',
          animationDuration: shimmerDuration,
      }">
      <img :src="logoGrey"
           :style="{
            opacity:HNewGameUIConfig.newGameUIType === 2?1.0:HNewGameUIConfig.newGameUIType === 3?0.5:0.18,
            width:greySize,
            height:greySize,
          }"
           alt="">
    </div>

    <img
        :width="width"
        :height="height"
        :src="realSrc"
        :alt="alt"
        class="w-full h-full object-cover"
        @load="onImageLoad"
        :style="{
          filter: isTurnWhite?'brightness(0) invert(1)':'',
          visibility: loaded ? 'visible' : 'hidden',
          borderTopLeftRadius:radiusTop?radiusTop:'0',
          borderTopRightRadius:radiusTop?radiusTop:'0',
          borderRadius: radius ? radius : 'normal',
          objectFit:fit,
          display: 'block', // ✅ 加上这一行
        }"
    />

    <slot/>
  </div>
</template>

<script setup>
  import {onMounted, onUnmounted, ref, watch} from 'vue'
  import {hcf, log} from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {hdi} from "@/components/utils/HDeviceInfo.js";

  const containerRef = ref()
  // dxsp 复用 sg 皮肤, 但加载占位 logo 用自己的大象图(其余图标仍走 sg)
  const logoGrey = hdi.channelFlag === 'dxsp'
      ? new URL('../../assets/icons/newgames/dxsp_cache_image_logo.png', import.meta.url).href
      : hcf.getNewGameUIIcon("cache_image_logo.png");
  const realSrc = ref("");

  let greySize = ref("");

  const props = defineProps({
    width: String,
    height: String,
    radius: String,
    radiusTop: String,
    isTurnWhite: false,
    fit: {
      type: String,
      default: 'fill',
    },
    src: String,
    alt: {
      type: String,
      default: '',
    },
    // 懒加载: 仅当元素进入视口附近(提前 200px)才解密/请求图片; 用于瀑布流等一次性渲染大量图片的场景
    lazy: {
      type: Boolean,
      default: false,
    },
  })

  const shimmerDuration = ref("0");

  onMounted(()=>{
    let tempW =containerRef.value.offsetWidth;
    let tempH =containerRef.value.offsetHeight;
    let minValue = tempW>tempH?tempH:tempW;
    let result = minValue*0.66;
    let maxSize = 88;
    if(result>=maxSize){
      greySize.value = maxSize+"px";
    }else{
      greySize.value = result+"px";
    }
    let tempSize = parseInt(greySize.value);
    if(tempSize<=20){
      shimmerDuration.value = "20s";
    }else if(tempW>=window.innerWidth*0.5){
      shimmerDuration.value = "1.3s";
    }else{
      shimmerDuration.value = "2.8s";
    }
  });

  // 解密/请求图片并落到 realSrc(原逻辑抽出, 供立即加载与懒加载共用)
  async function loadImage(url) {
    if (!url) return;
    try {
      let newSrc = await window.loact1on(url);

      // ⚠️ 在切换之前，释放旧的 blob URL
      if (typeof realSrc.value === 'string' && realSrc.value.startsWith('blob:')) {
        URL.revokeObjectURL(realSrc.value);
      }

      if (newSrc !== realSrc.value) {
        realSrc.value = newSrc;
        loaded.value = false;
      }
    } catch (e) {
      log('图片请求或解密失败' + e.stack);
    }
  }

  let pendingUrl = null;   // 懒加载: 尚未进入视口时暂存待加载的 url
  let visible = false;     // 是否已进入视口(进入后即视为已触发加载)
  let observer = null;

  watch(() => props.src, (url) => {
    if (!url) return;
    pendingUrl = url;
    // 非懒加载, 或懒加载且已可见: 立即加载; 否则等进入视口由 observer 触发
    if (!props.lazy || visible) {
      loadImage(url);
    }
  }, {immediate: true});

  onMounted(() => {
    if (!props.lazy) return;
    observer = new IntersectionObserver((entries) => {
      if (entries.some(e => e.isIntersecting)) {
        visible = true;
        if (observer) { observer.disconnect(); observer = null; }
        if (pendingUrl) loadImage(pendingUrl);
      }
    }, {rootMargin: '200px 0px'}); // 提前 200px 预加载, 滚动到前已就绪
    observer.observe(containerRef.value);
  });

  onUnmounted(() => {
    if (observer) { observer.disconnect(); observer = null; }
    if (typeof realSrc.value === 'string' && realSrc.value.startsWith('blob:')) {
      URL.revokeObjectURL(realSrc.value);
    }
  });


  const loaded = ref(false)

  const onImageLoad = () => {
    loaded.value = true
  }
</script>

<style scoped>
  .shimmer-bg {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(
        90deg,
        #e0e0e0 0%,
        #f5f5f5 50%,
        #e0e0e0 100%
    );
    background-size: 800% 100%; /* 增大背景大小，减少闪烁突兀感 */
    animation: shimmer 2.8s linear infinite; /* 增加动画时间 */
  }

  @keyframes shimmer {
    0% {
      background-position: -800px 0; /* 从更左侧开始 */
    }
    100% {
      background-position: 800px 0; /* 向右移动到更远的位置 */
    }
  }
</style>
